(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["greybird-recommendations"] && !Shopify.designMode) return;
  try {
    
  const GREYBIRD_RECOMMENDATIONS_API_ORIGIN = 'https://api-greybird-7hluh.ondigitalocean.app';
  const GREYBIRD_RECOMMENDATIONS_FETCH_TIMEOUT_MS = 20000;

  class GreybirdRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      if (!this.isPrimaryRail()) {
        this.remove();
        return;
      }

      this.initialized = true;
      if (this.dataset.projectionRendered === 'true') {
        this.wireCards();
        return;
      }
      if (this.dataset.fallbackEnabled === 'true') {
        this.fetchRecommendations();
      }
    }

    isPrimaryRail() {
      const rails = document.querySelectorAll('greybird-recommendations');
      const firstMatchingRail = Array.from(rails).find(
        (rail) => rail.dataset.shopifyProductGid === this.dataset.shopifyProductGid
      );
      return firstMatchingRail === this;
    }

    async fetchRecommendations() {
      if (this.fetchStarted) return;
      this.fetchStarted = true;

      const shopDomain = this.dataset.shopDomain;
      const shopifyProductGid = this.dataset.shopifyProductGid;
      const params = new URLSearchParams({
        shop_domain: shopDomain,
        shopify_product_gid: shopifyProductGid,
      });
      const url = GREYBIRD_RECOMMENDATIONS_API_ORIGIN + '/storefront/v1/recommendations/products?' + params.toString();
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), GREYBIRD_RECOMMENDATIONS_FETCH_TIMEOUT_MS);
      let response;
      try {
        response = await fetch(url, {
          signal: controller.signal,
          headers: { Accept: 'application/json' },
        });
      } catch (error) {
        return;
      } finally {
        clearTimeout(timeoutId);
      }
      if (!response.ok) return;

      let payload;
      try {
        payload = await response.json();
      } catch (error) {
        return;
      }
      this.renderFallbackItems(payload);
    }

    renderFallbackItems(payload) {
      if (
        payload === null ||
        typeof payload !== 'object' ||
        !isCanonicalUuid(payload.recommendation_id) ||
        !isCanonicalUuid(payload.source_product_id) ||
        !Array.isArray(payload.items) ||
        payload.items.length < 4 ||
        payload.items.length > 10
      ) {
        return;
      }

      const list = this.querySelector('.greybird-recommendations__list');
      if (!list || list.children.length > 0) return;

      const fragment = document.createDocumentFragment();
      const productIds = new Set([payload.source_product_id]);
      for (const item of payload.items) {
        if (!isValidFallbackItem(item) || productIds.has(item.product_id)) return;
        productIds.add(item.product_id);
        fragment.appendChild(
          buildFallbackCard(item, productIds.size - 2, payload.recommendation_id, payload.source_product_id)
        );
      }

      list.appendChild(fragment);
      this.removeAttribute('hidden');
      this.wireCards();
    }

    wireCards() {
      this.querySelectorAll('[data-recommendation-card]').forEach((card) => {
        const recommendation = readCardRecommendation(card);
        if (!recommendation) return;

        if (card.dataset.impressionPublished !== 'true') {
          card.dataset.impressionPublished = 'true';
          publishRecommendationEvent('greybird:recommendation_impression', recommendation);
        }
        if (card.dataset.clickBound !== 'true') {
          card.dataset.clickBound = 'true';
          card.addEventListener('click', () => {
            publishRecommendationEvent('greybird:recommendation_click', recommendation);
          });
        }
      });
    }
  }

  function isCanonicalUuid(value) {
    return (
      typeof value === 'string' &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
    );
  }

  function isReasonCode(value) {
    return value === 'same_category' || value === 'same_brand' || value === 'outlet_fallback';
  }

  function relativeStorefrontPath(value) {
    if (typeof value !== 'string') return null;
    try {
      const parsed = new URL(value);
      if (parsed.protocol !== 'https:') return null;
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return null;
    }
  }

  function isValidFallbackItem(item) {
    return (
      item !== null &&
      typeof item === 'object' &&
      isCanonicalUuid(item.product_id) &&
      relativeStorefrontPath(item.storefront_url) !== null &&
      typeof item.title === 'string' &&
      item.title.trim().length > 0 &&
      typeof item.image_url === 'string' &&
      item.image_url.startsWith('https://') &&
      item.price !== null &&
      typeof item.price === 'object' &&
      typeof item.price.amount_minor === 'number' &&
      Number.isFinite(item.price.amount_minor) &&
      (item.price.currency === 'JPY' || item.price.currency === 'USD') &&
      isReasonCode(item.reason_code)
    );
  }

  function formatPrice(price) {
    const minorDigits = price.currency === 'JPY' ? 0 : 2;
    const amount = price.amount_minor / Math.pow(10, minorDigits);
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: price.currency,
      minimumFractionDigits: minorDigits,
      maximumFractionDigits: minorDigits,
    }).format(amount);
  }

  function buildFallbackCard(item, position, recommendationId, sourceProductId) {
    const li = document.createElement('li');
    li.className = 'resource-list__item';

    const link = document.createElement('a');
    link.className = 'greybird-recommendations__card product-card';
    link.href = relativeStorefrontPath(item.storefront_url);
    link.dataset.recommendationCard = '';
    link.dataset.recommendationId = recommendationId;
    link.dataset.sourceProductId = sourceProductId;
    link.dataset.recommendedProductId = item.product_id;
    link.dataset.position = String(position);
    link.dataset.reasonCode = item.reason_code;

    const image = document.createElement('img');
    image.className = 'greybird-recommendations__media product-card__image';
    image.src = item.image_url;
    image.alt = item.title;
    image.loading = 'lazy';
    image.decoding = 'async';

    const title = document.createElement('p');
    title.className = 'greybird-recommendations__title';
    title.textContent = item.title;

    const price = document.createElement('p');
    price.className = 'greybird-recommendations__price';
    price.textContent = formatPrice(item.price);

    link.appendChild(image);
    link.appendChild(title);
    link.appendChild(price);
    li.appendChild(link);
    return li;
  }

  function readCardRecommendation(card) {
    const position = Number.parseInt(card.dataset.position, 10);
    if (
      !isCanonicalUuid(card.dataset.recommendationId) ||
      !isCanonicalUuid(card.dataset.sourceProductId) ||
      !isCanonicalUuid(card.dataset.recommendedProductId) ||
      !Number.isInteger(position) ||
      position < 0 ||
      position > 9 ||
      !isReasonCode(card.dataset.reasonCode)
    ) {
      return null;
    }
    return {
      recommendationId: card.dataset.recommendationId,
      sourceProductId: card.dataset.sourceProductId,
      recommendedProductId: card.dataset.recommendedProductId,
      position,
      reasonCode: card.dataset.reasonCode,
    };
  }

  function publishRecommendationEvent(eventName, recommendation) {
    if (
      typeof window === 'undefined' ||
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== 'function'
    ) {
      return;
    }
    window.Shopify.analytics.publish(eventName, {
      recommendation_id: recommendation.recommendationId,
      source_product_id: recommendation.sourceProductId,
      recommended_product_id: recommendation.recommendedProductId,
      position: recommendation.position,
      reason_code: recommendation.reasonCode,
    });
  }

  if (!customElements.get('greybird-recommendations')) {
    customElements.define('greybird-recommendations', GreybirdRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  if (!customElements.get('greybird-inventory-nudge')) {
    const nudgedProductIds = new Set();

    class GreybirdInventoryNudge extends HTMLElement {
      connectedCallback() {
        const productId = this.dataset.productId;
        const endpoint = this.dataset.endpoint;
        if (!productId || !endpoint || nudgedProductIds.has(productId)) return;

        nudgedProductIds.add(productId);
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('product_id', productId);
        if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(url.toString())) return;

        void fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          keepalive: true,
          headers: { Accept: 'application/json' },
        }).catch(() => undefined);
      }
    }

    customElements.define('greybird-inventory-nudge', GreybirdInventoryNudge);
  }

  } catch(e) { console.error(e); }
})();
})();
